module.exports = __webpack_public_path__ + "static/media/Somebody_Else.f7fb7f04.jpg";